export default __webpack_public_path__ + "assets/png/249f1b94862bff803789f198264e72dc.png";